import { useCallback, useEffect, useState } from 'react';
import { GOOGLE_CLIENT_ID } from 'Utils/constants';

declare global {
  interface Window {
    google: any;
  }
}

interface Gis {
  renderButton: (ref: HTMLDivElement, params: any) => void;
}

interface Props {
  onSubmit: (response) => void;
}

export default ({ onSubmit }: Props) => {
  const [gis, setGis] = useState<Gis | null>(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  const initGis = useCallback(() => {
    if (!scriptLoaded || !window.google?.accounts?.id) return;

    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: onSubmit,
    });

    setGis(window.google.accounts.id);

    window.google.accounts.id.prompt();
  }, [scriptLoaded, onSubmit]);

  useEffect(() => {
    if (!gis) {
      initGis();
    }
  }, [gis, initGis]);

  useEffect(() => {
    if (window.google?.accounts?.id) {
      setScriptLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;

    script.onload = () => setScriptLoaded(true);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return gis;
};
